import React from "react";
import { useDrop } from "react-dnd";

export const DroppableRow = ({ row, index, onDrop, selectedRowsID }) => {
    const [{ canDrop, isOver }, drop] = useDrop({
      accept: 'TABLE_CELL',
      drop: async (item) => {
        onDrop(item, index)
        return {...row?.original, selectedRowsID}
      },
      collect: monitor => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),  
    }),
    });

    const isActive = canDrop && isOver
  
    const rowProps = row.getRowProps({ style: { backgroundColor: isActive ? '#ccc' : 'transparent' } });
  
    return (
      <>
        <tr {...rowProps} ref={drop} kwy={row.index}>
          {row.cells.map((cell,i) => (
            <td key={i} style={{ backgroundColor: isActive && '#F5F5F5'  }} {...cell.getCellProps()}>{cell.render('Cell')}</td>
          ))}
        </tr>
      </>
    );
  };
  